import fetch from '@/config/fetch';


//登录
export const login = data => fetch('/api/admin/user/login',data,'POST');

//根据用户获取菜单
export const selMenuByLoginUser = () => fetch('/api/admin/resource/selMenuByLoginUser');

//后台模块列表
export const menuList = () => fetch('/api/admin/resource/menuList');

//角色列表
export const roleList = () => fetch('/api/admin/role/list');

//添加/修改角色信息
export const addRoleEdit = data => fetch('/api/admin/role/saveRole',data,'POST');

//菜单列表
export const menu = () => fetch('/api/admin/resource/menuList');

//根据用户选择菜单id
export const selMenuIds = data => fetch(`/api/admin/resource/selMenuIds/${data}`);

//设置权限
export const setPermissions = (id,data) => fetch(`/api/admin/role/setRight/${id}`,data,'POST');

//禁用/启用角色
export const updateStatusRole = (roleId,status) => fetch(`/api/admin/role/updateStatus/${roleId}/${status}`);

//后台账号列表
export const  accountList = () => fetch('/api/admin/user/accountList');

//添加账号
export const addUserAccount = data => fetch('/api/admin/user/addUserAccount',data,'POST');

//禁用/启用用户
export const updateStatusUser = (uid,status) => fetch(`/api/admin/user/updateStatus/${uid}/${status}`);

//重置密码
export const resetPwd = (uid) => fetch(`/api/admin/user/resetPwd/${uid}`);

//治疗师/调度员管理列表
export const userList_h = (pn,ps,data) => fetch(`/api/admin/user/userList/${pn}/${ps}`,data,'POST');

//编辑账号
export const editUserAccount = (data) => fetch('/api/admin/user/editUserAccount',data,'POST');

//治疗师认证列表
export const nurseCertList =  (pn,ps,data) => fetch(`/api/admin/user/nurseCertList/${pn}/${ps}`,data,'POST');

//编辑账号
export const editUserAccount_ = (data) => fetch('/api/admin/user/editUserAccount',data,'POST');

//查看患者认证资料(未审核/已认证)
export const patientCertDetail = (uid) => fetch(`/api/admin/user/patientCertDetail/${uid}`);

//审核认证（治疗师/患者）
export const examineCert = (data) => fetch('/api/admin/user/examineCert/v2',data,'POST');

//治疗师认证资料
export const certDetail = (uid) => fetch(`/api/admin/user/certDetail/${uid}`);

//治疗师签名列表
export const nurseSignList = (pn,ps,data) => fetch(`/api/admin/user/nurseSignList/${pn}/${ps}`,data,'POST');

/***
 *  上传图片 公共接口
 *  type:
 *  1.导管图
    2.出院小结
    3.维护手册
    4.身份证照片
    5.签名照片
    6.订单相关照片
    7.耗材相关
    8.服务相关
    9.基础数据相关
    10.banner图片
    11.平台收款码

    way: 存储方式；1.腾讯云存储   2.磁盘存储

 */

 export const uploadFile = (type,way,data) => fetch(`/api/upload/uploadImgFile`,data,'POST');


 //录入签名
 export const saveSign = (data) => fetch('/api/admin/user/saveSign',data,"POST");

 //患者账号列表
 export const patientAccountList = (pn,ps,data) => fetch(`/api/admin/user/patientAccountList/${pn}/${ps}`,data,'POST');

 //患者认证列表
 export const patientCertList = (pn,ps,data) => fetch(`/api/admin/user/patientCertList/${pn}/${ps}`,data,'POST');

 //报警/预警列表
 export const errList = (pn,ps,type) => fetch(`/api/admin/alarm/list/${pn}/${ps}/${type}`);



 /**
  * 根据类型查询基本数据
  *
  *  基础参数类型
  *  1-报警超时
  *  2-在线家庭协议
  *  3-治疗师保险协议条款
  *  4-服务须知
  *  5-患者保险费用
  *  6-远程协助费
  *  7-常规交通费用补贴
  *  8-远距离收费价格
  *  11.平台收款码
  */
 export const selectByType = (type) => fetch(`/api/admin/base/selectByType/${type}`);

 //根据id修改数据
 export const updateData = (data) => fetch('/api/admin/base/updateData',data,'POST');

 //添加基设置数据
 export const addSysBaseData = (data) => fetch('/api/admin/base/addSysBaseData',data,'POST');

 //治疗费用/耗材费用管理列表
 export const feeList = (type) => fetch(`/api/admin/base/feeList/${type}`);

 //添加/修改 治疗费用/耗材费用
 export const saveFeeInfo = (data) => fetch('/api/admin/base/saveFeeInfo',data,"POST");

 //删除治疗费用/耗材费用
 export const deleteFeeInfo = (id) => fetch(`/api/admin/base/deleteFeeInfo/${id}`,{},"DELETE");

 //查询医院管理
 export const selectHospital = () => fetch(`/api/hospital/selectHospital`);

  //添加/修改医院管理
  export const modifyHospital = (data) => fetch(`/api/hospital/saveOrUpdate`, data, 'POST');

 //服务类型列表
 export const serviceList = () => fetch('/api/admin/welfare/typeList');

 //添加/修改服务类型
 export const servicetType = (data) => fetch('/api/admin/welfare/saveServiceType',data,'POST');

 //删除服务
 export const delWelfare = (id) => fetch(`/api/admin/welfare/delWelfare/${id}`,{},"DELETE");

//删除服务类型
export const delServiceType = (id) => fetch(`/api/admin/welfare/delServiceType/${id}`,{},'DELETE');

//分页显示服务列表
export const welfareList = (pn,ps) => fetch(`/api/admin/welfare/bawelfareList/${pn}/${ps}`);

//添加服务
export const saveWelfare = (data) => fetch('/api/admin/welfare/saveWelfare',data,'POST');

//查看服务详情
export const welfareDetail = (id) => fetch(`/api/admin/welfare/welfareDetail/${id}`);

//删除服务
export const delWelfare_service = (id) => fetch(`/api/admin/welfare/delWelfare/${id}`,{},'DELETE');

//服务评价列表
export const welfareCommentList = (pn,ps) => fetch(`/api/admin/welfare/welfareCommentList/${pn}/${ps}`);

//评价列表
export const appraiseList = (pn,ps,welfareId) => fetch(`/api/admin/welfare/appraiseList/${pn}/${ps}/${welfareId}`);

//删除评价
export const deleteAppraise = (id) => fetch(`/api/admin/welfare/deleteAppraise/${id}`,{},'DELETE');

//订单列表
// export const orderList = (pn,ps,data) => fetch(`/api/admin/order/orderList/${pn}/${ps}`,data,'POST');
export const orderList = (pn,ps,data) => fetch(`/api/welfareOrder/selectAllTree/${pn}/${ps}`,data,'POST');

//订单列表头部信息
export const orderHeaderInfo = () => fetch('/api/admin/order/orderHeaderInfo/v2');

//查看订单详情
// export const openOrderDetail = (orderNo) => fetch(`/api/admin/order/orderDetail/${orderNo}`);
export const openOrderDetail = (orderNo) => fetch(`/api/admin/order/orderDetail/v2/${orderNo}`);

//诊前预评估内容
export const getAppraiseInfo = (orderNo) => fetch(`/api/admin/order/getAppraiseInfo/${orderNo}`);

//检验结果信息
export const getResultInfo = (orderNo) => fetch(`/api/admin/order/getResultInfo/${orderNo}`);

//banner列表
export const banner = () => fetch('/api/admin/banner/list');

//添加/修改banner
export const saveBanner = (data) => fetch('/api/admin/banner/saveBanner',data,"POST");

//删除banner
export const deleteBanner = (id) => fetch(`/api/admin/banner/deleteBanner/${id}`,{},'DELETE');

//意见反馈列表
export const feedback = (pn,ps) => fetch(`/api/admin/feedback/list/${pn}/${ps}`);

//删除反馈
export const  deleteFeedback = (id) => fetch(`/api/admin/feedback/deleteFeedback/${id}`,{},'DELETE');

//投诉列表
export const complaint = (pn,ps) => fetch(`/api/admin/complaint/list/${pn}/${ps}`);

//删除投诉
export const deleteComplaint = (orderNo) => fetch(`/api/admin/complaint/deleteComplaint/${orderNo}`,{},'DELETE');

//获取关于我们的信息
export const getAboutInfo = () => fetch('/api/admin/about/getAboutInfo');

//添加和修改关于我们
export const saveAbout = (data) => fetch('/api/admin/about/saveAbout',data,'POST');

//日志
export const loglist = (pn,ps,data) => fetch(`/api/admin/log/list/${pn}/${ps}`,data,'POST');

//维护评估记录
export const getEstimateInfo = (orderNo) => fetch(`/api/admin/order/getEstimateInfo/${orderNo}`);

//其他明细收费
export const otherFeeDetail = (orderNo) => fetch(`/api/admin/order/otherFeeDetail/${orderNo}`);

//地图监控
export const orderMonitor = () => fetch('/api/admin/order/orderMonitor');

//退出
export const logOut = () => fetch('/api/admin/user/logout',{},'DELETE');

//修改登录用户密码
export const updatePwd = (data) => fetch('/api/admin/user/updatePwd',data,'POST');

//财务管理
export const orderCensusList = (data) => fetch(`/api/admin/finance/orderCensusList`,data,'post');

export const orderCensusList1 = (pn, ps, data) => fetch(`/api/admin/finance/orderCensusTab`,data,'post');

//明细列表
export const orderCensusDetails = (pn,ps,data) => fetch(`/api/admin/finance/orderCensusDetails/${pn}/${ps}`,data,'post');

//分成比例列表
export const scaleList = () => fetch(`/api/admin/scale/list`);

//分成比例设置--修改
export const saveScale = (data) => fetch(`/api/admin/scale/saveScale`,data,'post');

//收入结算--列表
export const incomeList = (pn,ps,data) => fetch(`/api/admin/finance/incomeList/${pn}/${ps}`,data,'post');

//收入结算--结算明细列表
export const incomeDetails = (data) => fetch(`/api/admin/finance/incomeDetails`,data,'post');

//用户统计
export const userCensus = () => fetch('/api/admin/user/userCensus');

//订单量统计
export const homePageOrderCensus = (year) => fetch(`/api/admin/finance/homePageOrderCensus/${year}`);

//确认结算
export const confirmSettle = (id) => fetch(`/api/admin/finance/confirmSettle/${id}`)

//根据服务类型id查询服务名称下拉列表
export const selectNameByTypeId = (id) => fetch(`/api/name/selectNameByTypeId/${id}`, {}, 'post')

//分页查询服务名称列表
export const selectServiceName = (data) => fetch('/api/name/selectServiceName', data, 'post')

//添加服务名称
export const saveServiceName = (data) => fetch('/api/name/saveServiceName', data, 'post')

//修改服务名称
export const updateServiceName = (data) => fetch('/api/name/updateServiceName', data, 'post')

//删除服务名称
export const deleteServiceName = (id) => fetch(`/api/name/deleteServiceName/${id}`, {}, 'post')

// // 接单前评估接口
// //查询树题目名
// export const treeList = (data) => fetch('/api/beforePlaceOrderType/treeList', data, 'post') //患者下单前
// export const treeList1 = (data) => fetch('/api/diagnosisType/treeList', data, 'post') //诊前评估
// export const treeList2 = (data) => fetch('/api/beforeRecoveryPlanType/treeList', data, 'post') //康复计划
// export const treeList3 = (data) => fetch('/api/beforeMetaphaseType/treeList', data, 'post') //中期效果评估
// export const treeList4 = (data) => fetch('/api/beforeFinalType/treeList', data, 'post') //末期效果评估
// export const treeList5 = (data) => fetch('/api/beforeProcessType/treeList', data, 'post') //过程记录
// //添加/修改/树题目名
// export const saveOrUpdate = (data) => fetch('/api/beforePlaceOrderType/saveOrUpdate', data, 'post') //患者下单前
// export const saveOrUpdate1 = (data) => fetch('/api/diagnosisType/saveOrUpdate', data, 'post') //诊前评估
// export const saveOrUpdate2 = (data) => fetch('/api/beforeRecoveryPlanType/saveOrUpdate', data, 'post') //康复计划
// export const saveOrUpdate3 = (data) => fetch('/api/beforeMetaphaseType/saveOrUpdate', data, 'post') //中期效果评估
// export const saveOrUpdate4 = (data) => fetch('/api/beforeFinalType/saveOrUpdate', data, 'post') //末期效果评估
// export const saveOrUpdate5 = (data) => fetch('/api/beforeProcessType/saveOrUpdate', data, 'post') //过程记录
// //根据题目名查询内容
// export const selectByTypeId = (data) => fetch('/api/beforePlaceOrderBody/selectByTypeId', data, 'post') //患者下单前
// export const selectByTypeId1 = (data) => fetch('/api/beforeDiagnosisBody/selectByTypeId', data, 'post') //诊前评估
// export const selectByTypeId2 = (data) => fetch('/api/beforeRecoveryPlanBody/selectByTypeId', data, 'post') //康复计划
// export const selectByTypeId3 = (data) => fetch('/api/beforeMetaphaseBody/selectByTypeId', data, 'post') //中期效果评估
// export const selectByTypeId4 = (data) => fetch('/api/beforeFinalBody/selectByTypeId', data, 'post') //末期效果评估
// export const selectByTypeId5 = (data) => fetch('/api/beforeProcessBody/selectByTypeId', data, 'post') //过程记录
// //根据题目名保存内容
// export const saveOrUpdateBody = (data) => fetch('/api/beforePlaceOrderBody/saveOrUpdate', data, 'post') //患者下单前
// export const saveOrUpdateBody1 = (data) => fetch('/api/beforeDiagnosisBody/saveOrUpdate', data, 'post') //诊前评估
// export const saveOrUpdateBody2 = (data) => fetch('/api/beforeRecoveryPlanBody/saveOrUpdate', data, 'post') //康复计划
// export const saveOrUpdateBody3 = (data) => fetch('/api/beforeMetaphaseBody/saveOrUpdate', data, 'post') //中期效果评估
// export const saveOrUpdateBody4 = (data) => fetch('/api/beforeFinalBody/saveOrUpdate', data, 'post') //末期效果评估
// export const saveOrUpdateBody5 = (data) => fetch('/api/beforeProcessBody/saveOrUpdate', data, 'post') //过程记录

//根据题目名保存内容
export const saveOrUpdateBody = (data) => fetch('/api/beforePlaceOrderBody/saveOrUpdate', data, 'post') //患者下单前
export const saveOrUpdateBody1 = (data) => fetch('/api/beforeDiagnosisBody/saveOrUpdate', data, 'post') //诊前评估
export const saveOrUpdateBody2 = (data) => fetch('/api/beforeRecoveryPlanBody/saveOrUpdate', data, 'post') //康复计划
export const saveOrUpdateBody3 = (data) => fetch('/api/beforeMetaphaseBody/saveOrUpdate', data, 'post') //中期效果评估
export const saveOrUpdateBody4 = (data) => fetch('/api/beforeFinalBody/saveOrUpdate', data, 'post') //末期效果评估
export const saveOrUpdateBody5 = (data) => fetch('/api/beforeProcessBody/saveOrUpdate', data, 'post') //过程记录
export const saveOrUpdateBody6 = (data) => fetch('/api/baRiskAssess/saveOrUpdate', data, 'post') //风险评估

//查询
export const selectByServiceId = (data) => fetch('/api/beforePlaceOrderBody/selectByServiceId', data, 'post') //患者下单前
export const selectByServiceId1 = (data) => fetch('/api/beforeDiagnosisBody/selectByServiceId', data, 'post') //诊前评估
export const selectByServiceId2 = (data) => fetch('/api/beforeRecoveryPlanBody/selectByServiceId', data, 'post') //康复计划
export const selectByServiceId3 = (data) => fetch('/api/beforeMetaphaseBody/selectByServiceId', data, 'post') //中期效果评估
export const selectByServiceId4 = (data) => fetch('/api/beforeFinalBody/selectByServiceId', data, 'post') //末期效果评估
export const selectByServiceId5 = (data) => fetch('/api/beforeProcessBody/selectByServiceId', data, 'post') //过程记录
export const selectByServiceId6 = (data) => fetch("/api//baRiskAssess/selectByFile", data, 'post') //风险评估

// 服务录入复制
export const copyBodyByServiceId = (data) => fetch('/api/beforeDiagnosisBody/copyBodyByServiceId', data, 'post') //服务录入复制

export const changeBunk = (data) => fetch(`/api/welfareOrder/updateProduct/${data.welfareId}/${data.bunkProduct}`) //服务录入复制







// WEBPACK FOOTER //
// ./src/api/api.js